module.exports = __webpack_public_path__ + "img/germany.cc23f204.png";